// Strike is just numbers and empety
// const validInputRegexForStrike = /^-?(?:\d+|\d*\.\d+)$/
const validInputRegexForStrike = /^$|\d+$/;

export function isValidStirke(input: string): boolean {
  if (validInputRegexForStrike.test(input)) {
    return true;
  }
  return false;
}
